import { toRGBA } from "./utils";

const penelope = [254, 216, 221];
const p = (opacity: number = 1) =>
  toRGBA(penelope[0], penelope[1], penelope[2], opacity);

export default p;
